import { getContactSupportLink } from "@/features/branding";
import { buildEmbedProps, EmbeddableRow } from "../functions";
import { Embed } from "./index";
export const EmbedPageContent = (data: EmbeddableRow) => {
  const embedData = buildEmbedProps(data);
  return embedData ? <Embed data={embedData} data-sentry-element="Embed" data-sentry-component="EmbedPageContent" data-sentry-source-file="EmbedPageContent.tsx" /> : <>Could not load page. Please {getContactSupportLink()}.</>;
};